import React, { useState } from 'react';
import { IconButton, Typography } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import InfoIcon from '@mui/icons-material/Info';

import { getNumberComma } from '../../../utils/numberUtils';

const CostCalcRow = ({ cost, index }) => {
  const [toggleDesc, setToggleDesc] = useState(false);
  const handleToggleDesc = () => {
    setToggleDesc((prev) => !prev);
  };

  const isBal = cost?.masterTyp === 'BAL';

  return (
    <>
      <TableRow
        key={index}
        sx={{ 
          // 조정 행일 경우 배경색을 살짝 다르게 줄 수 있습니다.
          backgroundColor: isBal ? '#fdfdfd' : 'inherit',
          '& .MuiTableCell-root': { 
            fontSize: '0.875rem', 
            padding: '8px 4px', 
            textAlign: 'center',
            verticalAlign: 'middle' 
          },
          '& .MuiIconButton-root': { p: '4px' },
          '& .number-cell': { 
            textAlign: 'right',
            fontVariantNumeric: 'tabular-nums' 
          },
        }}   
      >
        <TableCell rowSpan={toggleDesc ? 2 : 1}>
          {index + 1}
          {/* [수정] masterTyp이 N도 아니고 BAL도 아닐 때만 별표 표시 */}
          {cost?.masterTyp !== 'N' && cost?.masterTyp !== 'BAL' && (
            <Typography variant="h6" color="error.main" component="span">
              *
            </Typography>
          )}
        </TableCell>
            
        <TableCell
          sx={{
            padding: '8px 12px', 
            textAlign: 'left !important',
            height: '32px',             
            whiteSpace: 'nowrap',       
            overflow: 'hidden',         
            textOverflow: 'ellipsis',   
          }}
        >
          {cost.productNm}
        </TableCell>

        <TableCell sx={{ width: 60, textAlign: 'center' }}>
          {/* [수정] BAL 행일 경우 사양보기 버튼 숨김 */}
          {!isBal && (
            <IconButton aria-label="사양보기" onClick={handleToggleDesc}>
              <InfoIcon />
            </IconButton>
          )}
        </TableCell>

        <TableCell sx={{ width: 80, textAlign: 'right' }}>
          {/* [수정] BAL 행일 경우 수량 - 표시 */}
          {isBal ? '' : getNumberComma(cost.expCnt)}
        </TableCell>

        <TableCell>
          {/* [수정] BAL 행일 경우 단위 - 표시 */}
          {isBal ? '' : cost.productUnit}
        </TableCell>

        <TableCell sx={{position: 'relative', textAlign: 'right !important'}}>
          {/* [수정] BAL 행일 경우 매출단가 - 표시 */}
          {isBal ? '' : getNumberComma(cost.unitVal)}
        </TableCell>

        <TableCell sx={{position: 'relative', textAlign: 'right !important', backgroundColor: '#f9f9f9'}}>
          {getNumberComma(cost.saleVal)}    
        </TableCell> 

        <TableCell sx={{position: 'relative', textAlign: 'right !important', backgroundColor: '#f9f9f9'}}>
          {getNumberComma(cost.saleValIn)}
        </TableCell>

        <TableCell sx={{position: 'relative', textAlign: 'right !important'}}>
          {/* [수정] BAL 행일 경우 매입단가 - 표시 */}
          {isBal ? '' : getNumberComma(cost.priceVal)}
        </TableCell>

        <TableCell sx={{position: 'relative', textAlign: 'right !important', backgroundColor: '#f9f9f9'}}>
          {getNumberComma(cost.buyVal)}
        </TableCell>

        <TableCell sx={{position: 'relative', textAlign: 'right !important', backgroundColor: '#f9f9f9'}}>
          {getNumberComma(cost.priceValIn)}
        </TableCell>

        <TableCell sx={{position: 'relative', textAlign: 'right !important'}}>
          {/* [수정] BAL 행일 경우 이익 - 표시 */}
          {isBal ? '' : getNumberComma(cost.saleProfit)}
        </TableCell>

        <TableCell sx={{ width: 80 , backgroundColor: '#f9f9f9'}}>
          {/* [수정] BAL 행일 경우 이익률 - 표시 */}
          {isBal ? '' : `${Number(cost.salePct || 0).toFixed(2)} %`}
        </TableCell>

        <TableCell>{cost.itemCd}</TableCell>
        <TableCell>{cost.sellPartnerNm}</TableCell>
      </TableRow>

      {/* [수정] BAL 행이 아닐 때만 상세 사양 영역 렌더링 */}
      {!isBal && toggleDesc && (
        <TableRow>
          <TableCell colSpan={12}>
            <Typography
              sx={{ whiteSpace: 'pre-line', py: 2, px: 3 }}
              variant="body2"
              component="div"
            >
              {cost?.productDesc}
            </Typography>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default CostCalcRow;
